import Cookies from 'js-cookie'

export const setCookie = (name: string, value: string, expiresInHours = 1) => {
  const expires = new Date()
  expires.setTime(expires.getTime() + expiresInHours * 60 * 60 * 1000)
  Cookies.set(name, value, { expires })
}

export const getCookie = (name: string): string | undefined => {
  return Cookies.get(name)
}

export const removeCookie = (name: string) => {
  Cookies.remove(name)
}

export const getQueryParam = (name: string): string | null => {
  if (typeof window === 'undefined') return null
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}
